import React from 'react';
import { Dumbbell, Target, TrendingUp } from 'lucide-react';

export default function Benefits({ lang }) {
  const t = {
    sectionTag: lang === 'bg' ? 'ЗАЩО НИЕ' : 'WHY US',
    headline: lang === 'bg' ? 'ЗАЩО SPORTAPPPROS' : 'WHY SPORTAPPPROS',
    cards: [
      {
        icon: Dumbbell,
        title: lang === 'bg' ? 'Навсякъде на терена' : 'On any field',
        desc:
          lang === 'bg'
            ? 'В залата, на терена или на пистата — тренирай навсякъде'
            : 'In the gym, on the pitch or on the track — train anywhere',
      },
      {
        icon: Target,
        title: lang === 'bg' ? 'За твоя спорт' : 'For your sport',
        desc:
          lang === 'bg'
            ? 'Специализирани програми за над 15 вида спорт'
            : 'Specialised programs for over 15 sports',
      },
      {
        icon: TrendingUp,
        title: lang === 'bg' ? 'Победи себе си' : 'Beat yourself',
        desc:
          lang === 'bg'
            ? 'Проследявай PR-ите си и чупи рекордите всяка седмица'
            : 'Track your PRs and break records every week',
      },
    ],
  };

  return (
    <section className="relative bg-[#0f172a] py-20 md:py-28 overflow-hidden">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-orange-500/5 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-14 md:mb-20">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="w-6 h-[2px] bg-orange-500" />
            <span className="text-orange-400 font-bold text-xs tracking-[0.3em] uppercase">
              {t.sectionTag}
            </span>
            <span className="w-6 h-[2px] bg-orange-500" />
          </div>
          <h2 className="font-black uppercase text-3xl sm:text-5xl md:text-6xl text-white leading-tight">
            {t.headline}
          </h2>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {t.cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <div
                key={i}
                className="group relative bg-[#1e293b] rounded-3xl p-8 md:p-10 border border-slate-700/50 hover:border-orange-500/60 transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                {/* Hover glow */}
                <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl" />

                {/* Icon */}
                <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-orange-500 to-amber-400 flex items-center justify-center mb-6 shadow-lg shadow-orange-500/30 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-7 h-7 text-white" />
                </div>

                {/* Number accent */}
                <div className="absolute top-8 right-8 text-6xl font-black text-white/5 select-none">
                  {String(i + 1).padStart(2, '0')}
                </div>

                <h3 className="relative font-black uppercase text-xl md:text-2xl text-white mb-3 tracking-wide">
                  {card.title}
                </h3>
                <p className="relative text-slate-400 text-base leading-relaxed">
                  {card.desc}
                </p>

                {/* Bottom accent bar */}
                <div className="mt-6 h-1 w-12 rounded-full bg-gradient-to-r from-orange-500 to-amber-400 group-hover:w-24 transition-all duration-300" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
